import { ErrorMessageEntity } from '../../Entities/ErrorMessage.Entity';
import { BaseFrontEndApiCalls } from './Base/Base.FrontEnd.Api.Calls';

export class ErrorMessageFrontEndApiCalls extends BaseFrontEndApiCalls {
    protected static _Entity = ErrorMessageEntity;

    // #region api

    // #endregion api
}
